import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/material";
import { getKardexHttp } from "actions/kardex";

export const useKardexTabla = () => {
    const intl = useIntl();
    const theme = useTheme();
    const navigate = useNavigate();

    const [procesando, setProcesando] = useState<boolean>(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [mensajeAlert, setMensajeAlert] = useState("");
    const handleisAlertOpen = () => setIsAlertOpen(true);
    const handleisAlertClose = () => setIsAlertOpen(false);

    const [kardex, setKardex] = useState<any[]>([]);

    // Estados para la paginación
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const getKardex = useCallback(async () => {
        try {
            setProcesando(true);
            const almacenes = await getKardexHttp();
            setKardex(almacenes);
            setProcesando(false);
        } catch (error) {
            setProcesando(false);
            const message = getErrorHttpMessage(error);
            setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
            handleisAlertOpen();
        }
    }, []);

    useEffect(() => {
        getKardex();
    }, []);

    // Handlers para la paginación
    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const kardexPaginado = useMemo(() => {
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return kardex?.slice(startIndex, endIndex) || [];
    }, [kardex, page, rowsPerPage]);

    return {
        intl,
        procesando,
        isAlertOpen,
        mensajeAlert,
        handleisAlertClose,
        kardexPaginado,
        page,
        rowsPerPage,
        handleChangePage,
        handleChangeRowsPerPage,
        kardex,
        theme,
    };
};
